import { Motivo } from "../shared/enums/motivo.enum";
import { StatusViagem } from "../shared/enums/status-viagem.enum";

export class PreCheckoutStatus{
    status_viagem: StatusViagem;
    motivo: Motivo;
    solicitacao_monitoramento: number;
    codigo_viagem: number;
    pedido_cliente: string;
    codigo_terminal: number;
    codigo_rece: number;
    Cpf: string;
}